import { useParams, Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { useState, useMemo, useEffect } from 'react';

interface CategoryTabsProps {
  currentSlug: string;
}

export default function CategoryTabs({ currentSlug }: CategoryTabsProps) {
  const [activeTab, setActiveTab] = useState(currentSlug);

  useEffect(() => {
    setActiveTab(currentSlug);
  }, [currentSlug]);

  return (
    <div className="flex items-center gap-1.5 overflow-x-auto pb-2 flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`flex items-center gap-1.5 px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap no-underline ${
            activeTab === cat.slug
              ? 'bg-primary-500 text-background-50 font-medium'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <i className={`${cat.icon} text-xs`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}